// @ts-nocheck
import * as React from "react";

const TxtFile: React.FC = () => {
    return (
        <svg viewBox="0 0 50 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.64044 26.1032V54.1917H48.157V11.9509H36.4051V1.84766H8.64044V8.15725H6.79738V0H38.9814C42.6477 3.36118 46.3338 6.74201 50.0001 10.1032V56H6.77759V26.0835H8.6206L8.64044 26.1032Z"
                fill="currentColor"
            />
            <path fillRule="evenodd" clipRule="evenodd" d="M0 9.57251H32.4813V24.7273H0V9.57251Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.3054 21.5823V14.2113H20.6498V12.6978H27.7445V14.2113H25.1088V21.5823H23.3054ZM12.0687 21.5823L15.1206 16.9631L12.3461 12.7174H14.4468L16.2304 15.5675L17.9744 12.7174H20.0553L17.2808 17.0417L20.3327 21.6019H18.1726L16.1908 18.5356L14.209 21.6019H12.0489L12.0687 21.5823ZM7.35208 21.5823V14.2113H4.71631V12.6978H11.8111V14.2113H9.1753V21.5823H7.37192H7.35208Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(TxtFile);
